import { type Revision, RevisionType } from '../types';
import { addUserEdits, randomUUID } from '../utils';

/**
 * Create a rollback revision.
 * It contains all content of the revision that the branch is rolled back to, and points
 * to that revision & the previously active revision of the branch to ensures a linear history.
 */
export function createRollbackRevision(
    toRevision: Revision,
    activeRevisionId: string,
    rollbackByUserId: string
): Revision {
    // Extract the git info from the revision, but don't include it in the rollback revision
    // as we don't want to preserve them in the history.
    const { git, ...rollbackClone } = structuredClone(toRevision);
    const edits = addUserEdits(rollbackClone.edits, [rollbackByUserId]);

    return {
        ...rollbackClone,
        id: randomUUID(),
        type: RevisionType.Rollback,
        parents: [activeRevisionId, toRevision.id],
        edits,
        rolledBackBy: rollbackByUserId,
    };
}
